var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pc-layout"},[_c('div',{staticClass:"custom-nav-bar"}),_c('div',{staticClass:"content"},[_c('router-view')],1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('p',[_vm._v("© 2025 以太坊钱包")])])
}]

export { render, staticRenderFns }